import { createAction } from "@reduxjs/toolkit";
import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import buildUrl from "build-url-ts";
import {
  FETCH_EXPERIENCES_WORKSPACES_REQUEST,
  FETCHING_EXPERIENCES_WORKSPACES_SUCCEEDED,
  FETCHING_EXPERIENCES_WORKSPACES_FAILED,
  FETCH_EXPERIENCES_WORKSPACE_REQUEST,
  FETCHING_EXPERIENCES_WORKSPACE_SUCCEEDED,
  FETCHING_EXPERIENCES_WORKSPACE_FAILED,
} from "../actionTypes";
import { WorkspaceItem } from "src/types/experiences/workspaces";

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const CLEVERSTORY_BASE_URL = `${cleverstoryApiUrl}/api/2.0`;

// ─── Workspaces List ──────────────────────────────────────────────────────────

const fetchExperiencesWorkspacesAPI = () =>
  axios.get(`${CLEVERSTORY_BASE_URL}/workspaces`).then((r) => r.data);

export const fetchExperiencesWorkspaces = createAction(
  FETCH_EXPERIENCES_WORKSPACES_REQUEST
);

const fetchingExperiencesWorkspacesSucceeded = createAction<WorkspaceItem[]>(
  FETCHING_EXPERIENCES_WORKSPACES_SUCCEEDED
);
const fetchingExperiencesWorkspacesFailed = createAction<any>(
  FETCHING_EXPERIENCES_WORKSPACES_FAILED
);

const fetchExperiencesWorkspacesSaga = function* (): any {
  try {
    const response = yield call(fetchExperiencesWorkspacesAPI);
    yield put(fetchingExperiencesWorkspacesSucceeded(response));
  } catch (error) {
    yield put(fetchingExperiencesWorkspacesFailed({ error }));
  }
};

// ─── Single Workspace (on dropdown select) ────────────────────────────────────

const fetchExperiencesWorkspaceAPI = (id: string) => {
  const url = buildUrl(CLEVERSTORY_BASE_URL, { path: `/workspaces/${id}` });
  return axios.get(url).then((r) => r.data);
};

export const fetchExperiencesWorkspace = createAction<string>(
  FETCH_EXPERIENCES_WORKSPACE_REQUEST
);

const fetchingExperiencesWorkspaceSucceeded = createAction<WorkspaceItem>(
  FETCHING_EXPERIENCES_WORKSPACE_SUCCEEDED
);
const fetchingExperiencesWorkspaceFailed = createAction<any>(
  FETCHING_EXPERIENCES_WORKSPACE_FAILED
);

const fetchExperiencesWorkspaceSaga = function* (
  action: ReturnType<typeof fetchExperiencesWorkspace>
): any {
  try {
    const response = yield call(fetchExperiencesWorkspaceAPI, action.payload);
    yield put(fetchingExperiencesWorkspaceSucceeded(response));
  } catch (error) {
    yield put(fetchingExperiencesWorkspaceFailed({ error }));
  }
};

// ─── Root Saga ────────────────────────────────────────────────────────────────

export default function* workspacesSaga() {
  yield takeEvery(FETCH_EXPERIENCES_WORKSPACES_REQUEST, fetchExperiencesWorkspacesSaga);
  yield takeEvery(FETCH_EXPERIENCES_WORKSPACE_REQUEST, fetchExperiencesWorkspaceSaga);
}
